import { IUser } from "../../data-types/user.interface";

export interface IUserState {
  user: IUser;
  id: number;
  isLoading: boolean;
  userError: string;
}

export const initialUserState: IUserState = {
  user: null,
  id: 0,
  isLoading: false,
  userError: null,
};
